<template>
    <div>
        <div class="wrap-input">

            <div class="input-box">
                <date-picker-lib
                        v-model="content"
                        format="dd MMMM yyyy"
                        input-class="input-field icon-calendar"
                        calendar-class="input-calendar"
                        :placeholder="placeHolder"
                        :id="inputId"
                        :language="datePickerLang"
                        :full-month-name="true"
                        @input="onChange($event)"
                        :disabled-dates="{to: new Date(formDate), from: new Date(lastDay) }"
                ></date-picker-lib>

            </div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import Locale from "@/helper/locale/locale.js";
import DateTimeHelper from '@/helper/DatetimeHelper.js';
import DatePickerLib from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker
import { th, en } from 'vuejs-datepicker/dist/locale'

/**
 * @property {String} inputId (required)
 * @property {Object} inputLbl (required)
 * @property {Object} errorInfo (required) Validation status. example : { isValid: true, msg: '',}
 */
export default {
    name: "DatePicker",
    components: {
        DatePickerLib
    },
    props: {
        value: String,
        inputId: String,
        placeHolder: String,
        errorInfo: Object,
        lastDay: String,
        formDate: String,
    },
    data: function() {
        return {
            label: '',
            content: this.value,
            placeholder: '',
            datePickerLang: th,
        };
    },
    mounted: function() {
        console.log("formDate" + this.formDate);
        if (Locale.getLocaleCode() == 1033) {
            this.datePickerLang = en;
        } else {
            this.datePickerLang = th;
        }
        this.initialDefaultValue();
        this.validateInput();
    },
    methods: {
        initialDefaultValue: function() {
            if (Util.isEmptyStr(this.value)) {
                return;
            }

            // for (var i of this.dropdownList) {
            //     if (i.value == this.value) {
            //         this.onChange(i);
            //         break;
            //     }
            // }
        },
        validateInput: function() {
            if(!this.inputLbl) return;
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Required
            if(this.inputLbl.required && Util.isEmptyStr(this.content)) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
        },
        onChange: function(event) {

            var daysList = ['วันอาทิตย์ที่','วันจันทร์ที่','วันอังคารที่','วันพุธที่','วันพฤหัสบดีที่','วันศุกร์ที่','วันเสาร์ที่'];

            this.validateInput();
            // var dateTime = new Date(event.getFullYear(), event.getMonth(), event.getDate());
            var dateTime = DateTimeHelper.cleanTimeFormDatetime(event);

            console.log(dateTime.getDay());
            var day = daysList[ dateTime.getDay() ];

            var time = DateTimeHelper.convertDateToTimeStampUnix(dateTime);

            var dateShow = day + " " + DateTimeHelper.dateFullThaiFormat(time);

            var tmpDate = dateTime.getDate() < 10 ? '0' + dateTime.getDate() : dateTime.getDate();
            var tmpMonth = dateTime.getMonth()+1 < 10 ? '0' + (dateTime.getMonth()+1) : dateTime.getMonth()+1;

            var date = String(dateTime.getFullYear()) + String(tmpMonth) + String(tmpDate);
            var data = {
                time: time,
                date: date,
                dateShow: dateShow
            }

            this.$emit('input', time + '');
            this.$emit('onDateChange', data);
        },
    },
}
</script>
<style lang="scss" >
    @import "@/style/base/base.scss";
    //@import "@/style/input/Text.scss";
    .wrap-input {
        //@extend %input-base;
        width: 100%;
        .input-box {
            //position: static;
            input {
                widows: 100%;
            }

            .placeholder  {
                top: -23px;
                z-index: 0;
            }
        }

        .input-field.icon-calendar {
            background-image: url('../../../assets/icon/calendar@2x.png');
            background-size: 20px;
            background-repeat: no-repeat;
            background-position-y: center;
            background-position-x: calc(100% - 10px);
            margin-top: 7px;
            background-color: rgba(0,0,0,0);
            border: 1px solid #A9A9A9;
            width: 100%;
            height: 40px;
            padding: 0.375rem 0.75rem;

            &:focus {
                outline: none;
            }
        }

        .input-calendar {
            z-index: 100;
            top: -290px;
        }


    }
</style>
